// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"sX-z","sponsoredTooltipWrapper":"tX-z","sponsoredTooltip":"uX-z","newCard":"vX-z"};